import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import Chapter from "./Chapter";
import ReferencesChapter from "./ReferencesChapter";
import { questionPropType } from "../../lib/dataShapes";
import { findReferencesInChapter, uniqueReferences } from "../../lib/utils";

const Chapters = ({ chapters, chaptersOrder, question }) => {
  const order = _.isEmpty(chaptersOrder) ? _.keys(chapters) : chaptersOrder;
  const outcomes = question.outcomes;
  let references = [];

  return (
    <div>
      {_(order).map(chapterKey => {
        const chapter = chapters[chapterKey];
        references = references.concat(
          findReferencesInChapter(chapter, outcomes)
        );
        return (
          <Chapter key={chapterKey} chapter={chapter} question={question} />
        );
      })}
      {!_.isEmpty(references) && (
        <ReferencesChapter references={uniqueReferences(references)} />
      )}
    </div>
  );
};

Chapters.propTypes = {
  chapters: PropTypes.objectOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      illustration: PropTypes.string.isRequired
    })
  ),
  chaptersOrder: PropTypes.arrayOf(PropTypes.string).isRequired,
  question: PropTypes.shape(questionPropType)
};

export default Chapters;
